import { Box, Skeleton } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';
import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import ScoreFaturamentoChart from '@/features/dashboard/components/ScoreFaturamentoChart.tsx';
import { useConsolidationScoreFaturamento } from '@/features/dashboard/api/getConsolidationScoreFaturamento.ts';
import LoadingChart from '@/features/dashboard/components/LoadingChart';

const ScoreHistoricoFinanceiro = ({ year: yearProp }: { year?: number }) => {
  const { data, isFetched, isFetching } = useConsolidationScoreFaturamento(yearProp);
  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched) {
      const currentYear = new Date().getFullYear();
      const listYears = Object.keys(groupBy(data, 'ano'))
        .map((item) => Number(item))
        .sort((a, b) => b - a);
      if (listYears.length) {
        setYear(year === null ? currentYear : year);
      }
    }
  }, [isFetched, data, year]);

  const onApplyFilter = (selectedYear) => {
    setYear(selectedYear);
  };

  const selected = data?.length ? data : null;
  return (
    <>
      <LoadingChart loading={isFetching} />

      {data?.length && selected && !isFetching && (
        <ScoreFaturamentoChart
          data={selected}
          color={'#15AB51'}
          title={'Histórico faturamento'}
          labelColor={'rgba(147, 220, 63, 1)'}
        />
      )}

      {isFetched && (
        <Box marginTop={'10px'}>
          <PeriodFilter
            year={year}
            years={Object.keys(groupBy(data, 'ano')).map(Number)}
            onApplyFilter={onApplyFilter}
          />
        </Box>
      )}
    </>
  );
};

export default ScoreHistoricoFinanceiro;
